
import {
    CollaboratingGroupContext,
    CrfForm,
    DEFAULT_FORM_BREADCRUMB_CREATOR,
    EventContext,
    EventDefinitionContext,
    Field,
    FormBreadcrumbs,
    FormContext,
    FormDefinitionContext,
    FormGrid,
    IFormGridCell,
    Input,
    InstitutionContext,
    KeyboardDatePicker,
    MasterGroupContext,
    PageLayout,
    PatientContext,
    RouteLoading,
    Select,
    Text
} from '@ngt/opms';
// import { Form } from '@ngt/opms';
import { Typography, makeStyles } from '@material-ui/core';
import { Permission, usePermissionsByIds } from '@ngt/opms-bctapi';
import { RequestState } from '@ngt/request-utilities';
import React, { FC, useContext } from 'react';
import * as Dtos from '../../api/dtos';

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const useStyles = makeStyles(theme => ({
    subHeading: {
        padding: theme.spacing(3, 3, 3, 3)
    }
}));

const permissions: Permission[] = [
    Permission.OpmsCrfUpdate,
    Permission.OpmsAdminister,
];

const financeMilestoneColumns: Array<IFormGridCell<Dtos.FinanceMilestone>> = [
    {
        name: 'milestoneId',
        minWidth: 700,
        maxWidth: 700,
        width: 700,
        content: (
            <Input
                component={Select}
            />
        )
    },
    {
        name: 'milestoneDate',
        content: (
            <Input
                component={KeyboardDatePicker}
            />
        )
    }
];



const RegistrationFormPage: FC = () => {
    const classes = useStyles();
    const { masterGroup } = React.useContext(MasterGroupContext);
    const { collaboratingGroup } = React.useContext(CollaboratingGroupContext);
    const { institution } = React.useContext(InstitutionContext);
    const { patient } = React.useContext(PatientContext);

    const [[canUpdateCrf], permissionLoadState] = usePermissionsByIds(permissions, masterGroup?.id, collaboratingGroup?.id, institution?.id, patient?.id, true);


    if (permissionLoadState.state === RequestState.None || permissionLoadState.state === RequestState.Pending) {
        return (
            <RouteLoading />
        );
    }

    const canEdit = canUpdateCrf &&
        !!institution &&
        !institution.recruitmentDisabled;


    const contextEventDefinition = useContext(EventDefinitionContext);
    const contextEvent = useContext(EventContext);
    const contextFormDefinition = useContext(FormDefinitionContext);
    const contextForm = useContext(FormContext);

    const ed = contextEventDefinition.eventDefinition;
    const e = contextEvent.event;
    const fd = contextFormDefinition.formDefinition;
    const f = contextForm.form;

    return (
        <PageLayout
            breadcrumbs={
                <FormBreadcrumbs
                    createPatientLink={(p, i) => DEFAULT_FORM_BREADCRUMB_CREATOR(p, i, ed, e, fd, f)}
                />}
        >
            <CrfForm
                formType={Dtos.Registration}
                validateOn="onChange"
                canEdit={canEdit}
            >
                
                    <Field
                        name="patientIdentifier"
                        component={Text}
                        disabled={!!patient?.patientStateId && patient?.patientStateId != Dtos.PatientStateType.New}
                    />
                    <Field
                        name="screeningDate"
                        component={KeyboardDatePicker}
                        disabled={!!patient?.patientStateId && patient?.patientStateId != Dtos.PatientStateType.New}
                    />
                    <Field
                        name="randomisationDate"
                        component={KeyboardDatePicker}
                        disabled={!!patient?.patientStateId && patient?.patientStateId != Dtos.PatientStateType.New}
                    />
                    <Field
                        name="plannedUseOfAbemaciclib"
                        component={Select}
                        disabled={!!patient?.patientStateId && patient?.patientStateId != Dtos.PatientStateType.New}
                    />

                
                <Typography
                    variant="h2"
                    color="primary"
                    className={classes.subHeading}
                >
                    Finance Milestone Dates
                </Typography>
                <FormGrid
                    type={Dtos.FinanceMilestone}
                    name="financeMilestones"
                    columns={financeMilestoneColumns}
                    rowLabel="Milestone"
                    allowAdd={true}
                />
            </CrfForm>
        </PageLayout>
    );
}

export default RegistrationFormPage